import React from 'react';
import {ThemeAwareSkeleton} from '@components/theme/ThemeAwareSkeleton';

const ProblemPictureSkeleton = () => {
    return (
        <div className="card">
            <ThemeAwareSkeleton
                style={{
                    width: '100%',
                    aspectRatio: 1,
                }}
            />
        </div>
    );
};

export default ProblemPictureSkeleton;
